import React, { useState } from 'react';
import { Box, SxProps, Theme, Tooltip } from '@mui/material';
import IconMi from 'components/common/icon/IconMi';
import useBundleTranslation from 'i18n';
import { IDialogItem } from 'app/concierge/types';
import { buildCopyContent, writeCopyContent } from 'app/concierge/tools/copyResponse';

export default function CopyResponseButton({ item, sx }: { item: IDialogItem; sx?: SxProps<Theme> }) {
    const { t } = useBundleTranslation(['app/concierge/widget']);
    const [copied, setCopied] = useState(false);
    const label = copied ? t('copy_response.copied') : t('copy_response.copy');

    const onClick = (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        const content = buildCopyContent(item, { origin: window.location.origin, sourcesLabel: t('sources') });
        writeCopyContent(content).then((done) => setCopied(done));
    };

    return (
        <Tooltip title={label} placement="top">
            <Box
                sx={sx}
                role="button"
                aria-label={label}
                onClick={onClick}
                onMouseLeave={() => setCopied(false)}
                data-test="concierge_copy_response"
            >
                <IconMi icon={copied ? 'check' : 'copy'} sx={{ fontSize: '16px' }} />
            </Box>
        </Tooltip>
    );
}
